import { render, staticRenderFns } from "./RegionDropdown.vue?vue&type=template&id=44fafc0e&"
import script from "./RegionDropdown.vue?vue&type=script&lang=ts&"
export * from "./RegionDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports